export const MoneyFormatter = ({ currencySymbol = '$', hideCents = false, value = 0 }) => {
  const parts = value.toString().split('.')
  const wholePart = parts[0] || '0'
  const fractionPart = parts[1] || '0'
  const wholeDisplay = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  if (hideCents === false) {
    let fractionDisplay = fractionPart
    if (fractionPart.length === 0) {
      fractionDisplay = '00'
    } else if (fractionPart.length === 1) {
      if (fractionPart[0] === '0') {
        fractionDisplay = `0${fractionPart}`
      } else {
        fractionDisplay = `${fractionPart}0`
      }
    } else {
      fractionDisplay = `${fractionPart[0]}${fractionPart[1]}`
    }
    return `${currencySymbol} ${wholeDisplay}.${fractionDisplay}`
  } else {
    return `${currencySymbol} ${wholeDisplay}`
  }
}
